import React, {useEffect, useRef, useState} from "react";
import {
    Button, TextField,
} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import { useSnackbar } from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import Grid from "@mui/material/Grid2";
import validator from 'validator';
import {useTranslation} from "react-i18next";
import MobileField from "../../../../components/elements/fields/MobileField";
import RayaField from "../../../../components/elements/fields/RayaField";
import {Phone} from "lucide-react";


const ChooseEmail = ({ setUser, setNextLevel, hasBack, iframe }) => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [fields, setFields] = useState({ email: "" });
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const validateFields = () => {
        const newErrors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.email)) {
            formIsValid = false;
            newErrors['email'] = t('emptyEmail');
        } else if (!validator.isEmail(fields.email)) {
            formIsValid = false;
            newErrors['email'] = t('wrongEmail');
        }

        setErrors(newErrors);
        return formIsValid;
    };

    useEffect(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 500);
    }, [inputRef]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (!validateFields()) {
            setSubmitLoading(false);
            return;
        }

        const data = new FormData();

        data.append("email", fields.email);

        try {
            const response =  await axios.post(
                `${defaultVariables.url}/auth/set-user`,
                data,
                { headers: { Accept: "application/json" } }
            );
            await setUser(response.data);
            await setNextLevel();
        } catch (error) {
            enqueueSnackbar(t("wrongEmail"), { variant: "error" });
            console.error(error.response);
        } finally {
            setSubmitLoading(false);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFields = { ...fields };
        let newErrors = { ...errors };
        newErrors[name] = "";
        newFields[name] = value;

        setFields(newFields);
        setErrors(newErrors);
    };
    return (
        <form  noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item size={12}>
                    <RayaField
                        ref={inputRef}
                        fullWidth
                        variant="outlined"
                        label={t('email')}
                        name="email"
                        dir="ltr"
                        type="email"
                        onChange={handleChange}
                        error={!!errors['email']}
                        helperText={errors['email']}
                        autoFocus
                    />
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        loading={submitLoading}
                        style={{width:"100%"}}
                        styleForParent={{margin:"10px 0"}}
                    >
                        {t("continue")}
                    </LoadingButton>
                </Grid>
                <Grid item size={12} style={{textAlign:"center"}}>
                    <Button
                        color="secondary"
                        component={Link}
                        startIcon={<Phone className='lucide-icon'/>}
                        to={'/login'}
                    >
                        {t('loginWithMobile')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default ChooseEmail;
